

























	import { Vue,Component,Prop } from 'vue-property-decorator'
    import { State,Action,Getter,namespace } from 'vuex-class'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    const site = namespace('site')
    const common = namespace('common')
    @Component({
        components:{
            Treeselect
        }
    })
    export default class Branch extends Vue{
        siteSearch:string = ''
        search = {
            name: '', //网点名
            site_org: null, //组织架构
            page: 1
        }
        activeSiteIndex:number = -2 //选择的网点index
        @site.State('list') siteList:any
        @site.State('sitePager') sitePager:any
        @site.State('loading') loading:any
        @Getter('siteOrg') siteOrg:any //组织架构

        @site.Action('getSiteList') getSiteList:any
        @common.Action('getPartner') getPartnerList:any
        created(){
            this.getList()
        }
        async getList(){
            await this.getSiteList(this.search)
        }
        // 配置树形图的参数
        normalizer(node:any) {
            let data = {}
            this.siteOrg.forEach((item:any) => {
                data = {
                    id: node["_id"],
                    label: node["name"],
                    children: node.children,
                }
            });
            return data
        }
        // 选择网点
        async chooseSite(index:number,id:string){
            this.activeSiteIndex = index;
            await this.getPartnerList({
                site:id
            })
            this.$emit('changeSite',id);
        }
        async siteChange(e:any){
            console.log(123);
            this.search.page = 1;
            this.search.site_org = e._id
            await this.getList();
        }
        handleCurrentChange(e:any){
            console.log(e);
            this.search.page = e;
            this.getList()
        }
    }
